import Swiper from 'swiper';

const mySwiper = new Swiper('.kn-hero-2 .swiper1', {
  slidesPerView: 1,
  allowTouchMove: false,
  followFinger: false,
  effect: 'fade',
  on: {
    slideChange: function () {
      $('.kn-hero-2 .items .item[data-slider='+mySwiper.activeIndex+']').addClass("active");
    },
  },
});

/*$('.kn-hero-2 .slider[data-slider="original"] .cta a.submit').click(function() {
  $('.kn-hero-2 .items').slideToggle();

  new Swiper('.kn-hero-2 .swiper2', {
    slidesPerView: 'auto',
    freeMode: true,
    // centeredSlides: true,
    // centeredSlidesBounds: true
  });
});*/

var myVar = setTimeout(timeToggle, 3000);

function timeToggle() {
  $('.kn-hero-2 .items').slideToggle();

  new Swiper('.kn-hero-2 .swiper2', {
    slidesPerView: 'auto',
    freeMode: true,
    // centeredSlides: true,
    // centeredSlidesBounds: true
  });
}

let currentSlider = 'original';

$('.kn-hero-2 .items .item').click(function() {
  $('.kn-hero-2 .items .item.active').removeClass("active");
  mySwiper.slideTo($(this).attr('data-slider'));
  $(".slde" + $(this).attr('data-slider') + " .popup").addClass("active");
  location.href = "#product" + $(this).attr('data-slider');

  // $('.kn-hero-2 .slider[data-slider=original]').hide();

  // const viewportWidth = $('.kn-hero-2').outerWidth();
  // const newSlider = $(this).attr('data-slider');

  // // $('.kn-hero-2 .slider')
  // //   .removeClass('active')
  // //   // .animate({
  // //   //     'left': viewportWidth
  // //   // },{ duration:500, queue:false,
  // //   // specialEasing: {'left':'linear','opacity':'linear'} })
  // //   .css({
  // //     left: -viewportWidth
  // //   });


  // $('.kn-hero-2 .slider.active')
  //   .animate({
  //       'left': viewportWidth,
  //   },{ duration:500, queue:false,
  //   specialEasing: {'left':'linear','opacity':'linear'} });

  // $('.kn-hero-2 .slider[data-slider="'+ newSlider +'"]').css("left", -viewportWidth).hide()
  // $('.kn-hero-2 .slider[data-slider="'+ newSlider +'"]')
  //   .addClass('active')
  //   .fadeIn()
  //   .animate({
  //       'left': 0,
  //       opacity: 1
  //   },{ duration:500, queue:false,
  //   specialEasing: {'right':'linear','opacity':'linear'} });

  //   // $('.kn-hero-2 .slider [data-aos]').removeClass("aos-init").removeClass("aos-animate")
  //   // window.scrollTo(0 ,window.scrollY+1)

  //   currentSlider = newSlider;
    

  // //  $(this).attr('data-slider')
})
